import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

type Props = React.ComponentProps<typeof Button> & {
  // "Brand", "Group by" — shown bold before the current value.
  label: string;
  value: string;
};

// The one button look every Inventory toolbar dropdown shares: "Label: value ▾".
// Spreads the rest of its props onto the Button so Radix triggers (asChild)
// can attach their handlers and ref.
export default function FilterTrigger({ label, value, className, ...props }: Props) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn(
        "h-8 max-w-60 gap-2 px-3 text-left text-xs font-normal focus-visible:ring-0 focus-visible:ring-offset-0",
        className,
      )}
      {...props}
    >
      <span className="truncate text-foreground">
        <span className="font-semibold">{label}:</span> {value}
      </span>
      <ChevronDown className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
    </Button>
  );
}
